import { render, staticRenderFns } from "./XSelect.vue?vue&type=template&id=f2a58dce&scoped=true"
import script from "./XSelect.vue?vue&type=script&lang=js"
export * from "./XSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a58dce",
  null
  
)

export default component.exports